import Swiper from './swiper';
import Shuffle from 'shufflejs';
import './imagefit';
import simpleParallax from './parallax';

const toggleMenu = (event) => {
  event.preventDefault();
  $('.js-menu-toggle, .megaMenu__nav').toggleClass('open');
  $('.header__logo').toggleClass('open');
};

$('.js-menu-toggle').on('click', toggleMenu);

function siteLoadIn() {
	$('body').addClass('loaded');
	setTimeout(function(){
		$('#preloader').fadeOut('slow');
	}, 2000);
	setTimeout(function(){
		$('#preloader').remove();
	}, 3000);
}

if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', siteLoadIn);
} else {  // `DOMContentLoaded` has already fired
	siteLoadIn();
}

// Check page scroll position for the sticky header

function checkScroll(){
  var scroll = $(window).scrollTop();

  if(scroll >= 50 ) {
    $('.header').addClass('header--sticky');
  } else {
    $('.header').removeClass('header--sticky');
  }
}

// Standard ready function for ready required scripts

$(document).ready(function() {
  if (document.querySelector('.header--game')) {
    checkScroll();
    $(window).scroll(checkScroll);
  };

  function listenToShareBtn() {
    $('.share .list .show').on('click', function(event) {
      event.preventDefault();
      $(this).next().slideToggle();
    });
  }
  listenToShareBtn();

  var image = document.getElementsByClassName('parallax');
    new simpleParallax(image, {
      delay: .6,
      scale: 1.35,
      transition: 'cubic-bezier(0,0,0,1)'
  });

  var image = document.getElementsByClassName('parallaxFull');
    new simpleParallax(image, {
      delay: .6,
      scale: 1.25,
      transition: 'cubic-bezier(0,0,0,1)'
  });

  $('.careers__categorySelect').change(function(){
    var filter = $('#filter');
    var currentCategory = document.querySelector('.careers__currentCategory strong');
    var filterCategory = $(this).find(':selected').attr('data-slug');
    var loadMoreBtn = $('.js-load-more-jobs')

		$.ajax({
			url: filter.attr('action'),
			data: filter.serialize(),
			type: filter.attr('method'),
			beforeSend:function(xhr){},
			success:function(data){
        $(currentCategory).text(filterCategory);
        $('.careers__grid .careers__block').fadeOut(300, function() {
          $('.careers__grid').empty();
          $('#response').append(data);
          $('.careers__grid').css('transform', 'translateX(0)');
          $('.careers__grid .careers__block').fadeIn(500);
          loadMoreBtn.data('pageNumber', 2)
          loadMoreBtn.text('Load more')
          loadMoreBtn.prop('disabled', false);
          initJobFetchers();
        });

				//$('#response').html(data);
			}
		});
		return false;
  });

  // Listener for job close button
  function initJobCloser() {
    if ( $('.js-role-close').length ) {
      $('.js-role-close').click(function() {
        $(this).parents('.js-role').fadeOut(300)
      })
    }
  }
  initJobCloser()

  // Scroll to role if the page has a param
  var pagePath = window.location.pathname === '/careers/'
  var urlParam = !!window.location.search
  if ( pagePath && urlParam && $('.careers__top').length ) {
    scrollToTop(null, '.careers')
  }

  // Fetch job item data
  function initJobFetchers() {
    $('.js-jobs-card').click(function(event) {
      event.preventDefault()

      var targetPost = $(this).data('postId');
      var targetSlug = $(this).data('postSlug');
      var containerEl = $('.js-role-container');
      var currentRoleEl = $('.js-role-container .js-role');

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        data: 'action=fetchJobDetails&jobPostId='+targetPost,
        type: 'POST',
        beforeSend:function(xhr){},
        success:function(data){
          containerEl.css('height', containerEl.innerHeight())
          currentRoleEl.fadeOut('300', function() {
            currentRoleEl.remove();
            setTimeout(() => {
              containerEl.prepend(data)
              containerEl.find('.js-role').fadeIn('300')
              scrollToTop(null, '.careers')
              containerEl.css('height', 'auto')
              var queryParam = {'role': targetSlug}
              var newUrl = document.location.origin + document.location.pathname + '?' + $.param(queryParam)
              window.history.replaceState({}, document.title, newUrl);
              initJobCloser()
              listenToShareBtn()
            }, 100);
          })
        }
      });
    })
  }
  initJobFetchers();

  // Load more job posts
  $('.js-load-more-jobs').click(function(event) {
    event.preventDefault()
    var btn = $(this)
    var postPerPage = btn.data('ppp')
    var category = $('.careers__categorySelect').val()
    var pageNumber = btn.data('pageNumber')
    var jobsContainerEl = $('#response')
    var payload = 'action=loadMoreJobs&postPerPage='+postPerPage+'&pageNumber='+pageNumber+'&cat='+category

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: payload,
      type: 'POST',
      beforeSend:function(xhr){},
      success:function(data){
        if (data === 'empty') {
          btn.prop('disabled', true);
          btn.text('All careers loaded')
        } else {
          jobsContainerEl.append(data)
          btn.data('pageNumber', pageNumber + 1)
          initJobFetchers()
        }
      }
    });
  })
});


if (document.querySelector('.clients__slider')) {
  var clientsSlider = new Swiper ('.clients__slider', {
    slidesPerView: 1,
    loop: true,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },

      1200: {
        slidesPerView: 3,
        spaceBetween: 58,
      },

      1490: {
        slidesPerView: 5,
      },
    }
  });
};

if (document.querySelector('.team__slider')) {
  var teamSlider = new Swiper ('.team__slider', {
    slidesPerView: 1,
    spaceBetween: 20,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },

      1200: {
        slidesPerView: 3,
        spaceBetween: 58,
      },

      1490: {
        slidesPerView: 5,
        spaceBetween: 58,
      },
    }
  });
};

if ($('.awards__slider').length > 0) {
  let swiperInstances = [];
  $(".awards__slider").each(function(index, element){
    const $this = $(this);
    $this.addClass("instance-" + index); //instance need to be unique (ex: some-slider)
    $this.parent().find(".swiper-button-prev").addClass("prev-" + index); //prev must be unique (ex: some-slider-prev)
    $this.parent().find(".swiper-button-next").addClass("next-" + index); //next must be unique (ex: some-slider-next)
    swiperInstances[index] = new Swiper(".instance-" + index, { //instance need to be unique (ex: some-slider)
      // your settings ...
      navigation: {
        prevEl: ".prev-" + index,  //prev must be unique (ex: some-slider-prev)
        nextEl: ".next-" + index, //next must be unique (ex: some-slider-next)
      },
      slidesPerView: 1,
      freeMode: true,
      centeredSlides: true,
      speed: 6000,
      loop: true,
      autoplay: {
        delay: 1,
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 58,
        },

        1490: {
          slidesPerView: 5,
          spaceBetween: 90,
        },
      }
    });
  });

  // Now you can call the update on a specific instance in the "swiperInstances" object
  // e.g.
  swiperInstances[3].update();
  //or all of them
  // setTimeout(function () {
  //   for (const slider of swiperInstances) {
  //     slider.update();
  //   }
  // }, 50);
};

if (document.querySelector('.gamesBanner__slider')) {
  var gamesBannerText = new Swiper('.gamesBanner__smallText', {
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
  });

  var gamesBanner = new Swiper ('.gamesBanner__slider', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return ('0' + current).slice(-2) + ' — ' + ('0' + total).slice(-2);
      }
    },
    thumbs: {
      swiper: gamesBannerText
    }
  });
};

if (document.querySelector('.testimonials__slider')) {
  var testimonialsText = new Swiper('.testimonials__smallText', {
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
  });

  var testimonials = new Swiper ('.testimonials__slider', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return ('0' + current).slice(-2) + ' — ' + ('0' + total).slice(-2);
      }
    },
    thumbs: {
      swiper: testimonialsText
    }
  });
};

if (document.querySelector('.sliderContent__slider')) {
  var gamesBanner = new Swiper ('.sliderContent__slider', {
    slidesPerView: 1,
    effect: "fade",
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-numbers',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return ('0' + current).slice(-2) + ' <span class="chevron"></span> ' + ('0' + total).slice(-2);
      }
    }
  });
};

// Scroll Top
var btn = $('#scrollTop');
btn.on('click', scrollToTop);
function scrollToTop(e, selector = false) {
  if (e) {
    e.preventDefault();
  }

  var scrollOffset = 0;

  if (selector) {
    scrollOffset = $(selector).offset().top - 50
  }

  $([document.documentElement, document.body]).animate({
    scrollTop: scrollOffset,
  }, '1000');
}
